import {getToken, onMessage} from "firebase/messaging";
import React, {useState} from "react";
import {messaging} from "@config/firebase.ts";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";
import {postNotification} from "@store/notificationSlice.tsx";
import {useNavigate} from "react-router";
import {endCall, setCall} from "@store/callSlice.tsx";
import {Box, Button, Card, Typography} from "@mui/material";
import {fetchTicketDetailsById} from "@store/ticketListSlice";

const NotificationRequest: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [showNotificationPopup, setShowNotificationPopup] = useState(false);
    const [permissionDenied, setPermissionDenied] = useState(false);
    const { ticketId, startCall } = useSelector((state: any) => state.call);
    const [notificationState, setNotificationState] = useState("");
    const checkNotificationPermission = async () => {
        const notificationPermission = await navigator.permissions.query({
            name: "notifications" as PermissionName,
        });
        setNotificationState(notificationPermission.state);
        if (
            notificationPermission.state === "prompt" ||
            notificationPermission.state === "denied"
        ) {
            setShowNotificationPopup(true);
        }
        return notificationPermission.state;
    };

    const getTicketIdFromUrl = () => {
        const pathParts = window.location.pathname.split("/");
        return pathParts.includes("chat") ? pathParts[pathParts.indexOf("chat") + 1] : null;
    };

    const message = React.useCallback(
        (e: any) => {
            const notifData = e.notification;
            if (
                e.data?.navigationId === "call" &&
                e.data.action === "incoming" &&
                !ticketId
            ) {
                dispatch(
                    setCall({
                        ticketId: e.data.ticketId,
                        hasVideo: e.data.hasVideo === "true",
                    })
                );
            }
            if (e.data?.navigationId === 'call' && e.data.action === 'ended' && ticketId.toString() === e.data.ticketId && !startCall) {
                dispatch(endCall())
            }
            if (notifData?.title) {
                const notification = new Notification(notifData.title, {
                    body: notifData.body,
                    data: {url: `/chat/${e.data?.ticketId}`},
                    navigate: `/chat/${e.data?.ticketId}`
                });
                const id = getTicketIdFromUrl();
                if (id && e.data?.ticketId) {
                    dispatch(fetchTicketDetailsById({id: e.data?.ticketId}));
                }
                console.log(notification, 'notification inside');
                // Handle click event on the notification
                notification.onclick = () => {
                    console.log('clicked inside')
                    window.focus();
                    navigate(notification?.data?.url);
                };
            }
            saveFCMToken();
        },
        [ticketId, startCall]
    );

    const saveFCMToken = async () => {
        const token = await getToken(messaging, {
            vapidKey:
                "BDSGbhwI5GXuCJxu-DlosbB3acHxTWNEn_uyxrGf2JPx2RotbdqZRwBWpj2VSxxCheECSCyPd9QfH1VM7oczG7s",
        });
        console.log("token", token);
        if (token) {
            const notificationData = {
                fcmToken: token,
                platform: "Web",
            };
            dispatch(postNotification(notificationData));
        }
        return token
    }

    const requestPermission = async () => {

        try {
            const currentStatus = await checkNotificationPermission();
            const permission = await Notification.requestPermission();
            console.log("currentStatus", currentStatus);
            console.log("permission", permission);
            if (permission === "granted" || currentStatus === "granted") {
                setShowNotificationPopup(false);
                setPermissionDenied(false);
                // Generate Device Token for notification
                await saveFCMToken()
            } else if (permission === "denied" && (notificationState === "denied" || notificationState === "prompt")) {
                setPermissionDenied(true);
                console.log("Denied for the notification");
            }
        } catch (e) {
            const token = await saveFCMToken()
            if (!token) {
                setShowNotificationPopup(true);
                setPermissionDenied(false);
            }
        }
    };

    React.useEffect(() => {
        requestPermission();
        setInterval(() => {
            saveFCMToken();
        }, 15000)
    }, []);

    React.useEffect(() => {
        const unsubscribe = onMessage(messaging, message);
        return unsubscribe;
    }, [message]);

    return (
            <>
                {showNotificationPopup && (
                    <Card
                        sx={{
                            position: "fixed",
                            bottom: 38,
                            right: 20,
                            width: 300,
                            p: 2,
                            boxShadow: 4,
                            zIndex: 9999,
                        }}
                    >
                        <Typography variant="h6">Enable Notifications</Typography>
                        {permissionDenied ? (
                            <Typography variant="body2" sx={{mb: 2}}>
                                Allow Notifications from browser settings and refresh browser.
                            </Typography>
                        ) : (
                            <Typography variant="body2" sx={{mb: 2}}>
                                Allow notifications to stay updated with important alerts.
                            </Typography>
                        )}

                        <Box display="flex" justifyContent="flex-end" gap={1}>
                            {!permissionDenied && (
                                <Button variant="contained" onClick={requestPermission}>
                                    Allow
                                </Button>
                            )}
                        </Box>
                    </Card>
                )}
            </>
    );
};

export default NotificationRequest;
